<template>

  <!-- Banners Area -->
  <div class="banner-area section-padding-xs">
    <div class="container">
      <div class="row banners-masonry-active banners-wrapper">
        <!-- Single Banner -->
        <div :class="item.colsClass+' col-md-6 col-12 masonry-item'" v-for="item in bannerAreas">
          <a :href="item.url" :title="item.name" class="banner mt-30">
            <img :src="item.pic" :title="item.name" alt="best banner image">
            <div class="banner-content banner-content-2 text-center">
              <h3>{{item.name}}</h3>
              <p>{{item.note}}</p>
            </div>
          </a>
        </div>
        <!--// Single Banner -->
      </div>
    </div>
  </div>
  <!--// Banners Area -->
</template>

<script>
    import {getLAdvertise} from '@/api/advertise'
    export default {
       name: "index",
       data(){
          return {
            bannerAreas:[]
          }
       },
       beforeCreate(){
         let _this = this
         getLAdvertise(2).then(res=>{
            if(res.data.code === 200){
              _this.bannerAreas = res.data.data
              setTimeout(function(){
                $('.banners-masonry-active').imagesLoaded( function() {
                  $('.banners-masonry-active').masonry({
                    itemSelector: '.masonry-item',
                    columnWidth: 1
                  });

                });
              },200)
            }

         })
       }
    }
</script>

<style scoped>

</style>
